import { render, staticRenderFns } from "./ReeditLocalClipTemplate.vue?vue&type=template&id=671b1386&scoped=true"
import script from "./ReeditLocalClipTemplate.vue?vue&type=script&lang=js"
export * from "./ReeditLocalClipTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671b1386",
  null
  
)

export default component.exports